import Link from 'next/link'
import { NextSeo } from 'next-seo'
import { Header } from '@components/Header'
import { Footer } from '@components/Footer'
import { ArrowDownIcon, ExternalLinkIcon } from '@heroicons/react/solid'

const resources = [
  {
    image:
      'https://md-downloadables.s3-us-west-2.amazonaws.com/buyer-handout-thumbnail.png',
    href:
      'https://md-downloadables.s3-us-west-2.amazonaws.com/Majordomo-Buyer-Handout.pdf',
    title: 'Buyer Handout',
    description:
      'A 2-page document to share with buyers the benefits of ording a Domoreport, and what the Domoreport looks like.',
    background: 'transparent'
  },
  {
    image:
      'https://md-downloadables.s3-us-west-2.amazonaws.com/Majordomo-Logo-Black.png',
    href:
      'https://md-downloadables.s3-us-west-2.amazonaws.com/Majordomo-Logo-Black.png',
    title: 'Majordomo Logo',
    description: 'Black Majordomo logo with transparent background.',
    background: 'transparent'
  },
  {
    image:
      'https://md-downloadables.s3-us-west-2.amazonaws.com/Majordomo-Logo-Color.png',
    href:
      'https://md-downloadables.s3-us-west-2.amazonaws.com/Majordomo-Logo-Color.png',
    title: 'Majordomo Logo',
    description: 'Blue and grey Majordomo logo with white background.',
    background: 'white'
  },
  {
    image:
      'https://md-downloadables.s3-us-west-2.amazonaws.com/Majordomo-Logo-White.png',
    href:
      'https://md-downloadables.s3-us-west-2.amazonaws.com/Majordomo-Logo-White.png',
    title: 'Majordomo Logo',
    description: 'White Majordomo logo with transparent background.',
    background: 'gray-300'
  }
]

export default function AgentToolkit() {
  return (
    <>
      <NextSeo
        title="Agent Toolkit | Home Repair Pricing After An Inspection"
        description="Download our free resources from Majordomo and explain to your buyers how Majordomo fits into your buying process."
        canonical="https://majordomo.com/home-agent-toolkit"
        openGraph={{
          url: 'https://majordomo.com/home-agent-toolkit',
          title:
            'Agent Toolkit | Home Repair Pricing After An Inspection | Majordomo',
          description:
            'Download our free resources from Majordomo and explain to your buyers how Majordomo fits into your buying process.',
          images: [
            {
              url:
                'https://majordomo.com/images/home-agent-toolkit/home-agent-toolkit.png',
              width: 771,
              height: 690,
              alt: 'Black coffee mug with 80/20 printed on it'
            }
          ]
        }}
      />
      <Header />

      <main className="pt-8 px-0 container mx-auto">
        <div className="flex md:flex-row flex-col justify-between items-center lg:pb-36 pb-12">
          <div className="flex flex-col md:items-start items-center justify-center w-full 2xl:p-36 xl:p-20 md:p-8 md:order-first order-last">
            <div className="flex items-center border-gray-200 mb-4 pb-4 md:w-full">
              <h4 className="text-2xl font-black tracking-wide">
                Agent Toolkit
              </h4>
            </div>

            <p className="w-full max-w-lg md:p-0">
              Download these free resources from Majordomo and use them to
              explain to your buyers how Majordomo fits into your buying
              process. If there's a resource you'd like us to create,{' '}
              <Link href="/contact-us">
                <a className="text-accentBlue hover:underline font-black">
                  send us a message
                </a>
              </Link>{' '}
              and we'll get on it.
            </p>

            <p className="flex items-center mt-12 font-black">
              Check out resources below{' '}
              <ArrowDownIcon
                width={24}
                height={24}
                className="text-gold-400 ml-2"
              />
            </p>
          </div>

          <img
            src="/images/agent-toolkit/agent-toolkit.png"
            className="md:order-last order-first md:mb-0 mb-8 folded-l-max"
            width="50%"
          />
        </div>

        <div className="max-w-7xl mx-auto px-8">
          <div className="lg:pb-36 pb-12">
            <h4 className="text-2xl font-black mb-12 border-black border-b">
              Majordomo Resources
            </h4>

            <div className="grid grid-cols-2 gap-4">
              {resources.map(resource => {
                return (
                  <div
                    className="flex rounded-lg border-gray-200 border bg-gray-50"
                    key={resource.href}
                  >
                    <div
                      className={`flex items-center w-1/3 p-4 rounded-l-lg bg-${resource.background}`}
                    >
                      <Link href={resource.href}>
                        <a target="_blank" rel="noopener noreferrer">
                          <img
                            src={resource.image}
                            className="w-full rounded-l-lg object-contain h-20"
                          />
                        </a>
                      </Link>
                    </div>
                    <div className="relative flex flex-col justify-center w-2/3 p-4">
                      <h4 className="font-black text-xl">{resource.title}</h4>
                      <p>{resource.description}</p>

                      <div>
                        <a
                          href={resource.href}
                          className="flex items-center text-accentBlue font-black hover:underline mt-4"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View Resource
                          <ExternalLinkIcon
                            width={16}
                            height={16}
                            className="ml-1"
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </>
  )
}
